import React from 'react'
import { IoMdMail } from "react-icons/io";

const TopNavbar = () => {
  return (
    <div className='bg-primaryFadedColor text-white hidden lg:block font-extralight'>
      <article className='max-w-[1400px] mx-auto  px-6 py-1 flex justify-between items-center'>
        <h1>“Smart Staffing for a Smarter Tomorrow”</h1>
        <h1 className='flex items-center gap-1'><IoMdMail className='text-2xl' />swayansidha.m@natioinfotech.com</h1>
      </article>
    </div>
  )
}

export default TopNavbar